import { useIntl } from 'react-intl';
import { Fields } from 'redux-form';

import { NameComponent } from './NameComponent';
import messages from './NameField.messages';
import styles from './NameField.module.css';

const NameField = (props) => {
    const { label, ...restProps } = props;
    const intl = useIntl();

    const names = ['title', 'firstName', 'lastName'];

    const placeholder = {
        title: intl.formatMessage(messages.title),
        first_name: intl.formatMessage(messages.firstName),
        last_name: intl.formatMessage(messages.lastName)
    };

    return (
        <div className={styles.NameField}>
            <label className={styles.label}>{label}</label>
            <Fields
                placeholder={placeholder}
                names={names}
                component={NameComponent}
                {...restProps}
            />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default NameField;
